// color presets for tags
export const colorPresets = [
  {
    color: '#344054',
    bg: '#F2F4F7'
  }, {
    color: '#B42318',
    bg: '#FEF3F2'
  }, {
    color: '#B54708',
    bg: '#FFFAEB'
  }, {
    color: '#027A48',
    bg: '#ECFDF3'
  }, {
    color: '#363F72',
    bg: '#E0E8FF'
  }, {
    color: '#026AA2',
    bg: '#F0F9FF'
  }, {
    color: '#175CD3',
    bg: '#EFF8FF'
  }, {
    color: '#3538CD',
    bg: '#EEF4FF'
  }, {
    color: '#5925DC',
    bg: '#F4F3FF'
  }, {
    color: '#C11574',
    bg: '#FDF2FA'
  }, {
    color: '#C01048',
    bg: '#FFF1F3'
  }, {
    color: '#B93815',
    bg: '#FEF6EE'
  }];


export const getRandColor = () => {
  const rand = Math.floor(Math.random() * colorPresets.length);
  const colorObj = colorPresets[rand];
  return colorObj;
};



// WEBPACK FOOTER //
// ./src/components/common/tagColorPreset.js